import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../views/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "",
        name: "Home",
        component: () => import("../views/Home.vue"),
      },
      {
        path: "about",
        name: "About",
        component: () => import("../views/About.vue"),
      },
      {
        path: "ServiceTenet",
        name: "ServiceTenet",
        component: () => import("../views/ServiceTenet.vue"),
      },
      {
        path: "ServiceContent",
        name: "ServiceContent",
        component: () => import("../views/ServiceContent.vue"),
      },
      {
        path: "ServiceSence",
        name: "ServiceSence",
        component: () => import("../views/ServiceSence.vue"),
      },
      {
        path: "ServiceCase",
        name: "ServiceCase",
        component: () => import("../views/ServiceCase.vue"),
      },
      {
        path: "Honor",
        name: "Honor",
        component: () => import("../views/Honor.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
